import { useUserRoleSelector } from "store";
import { RoleName } from "../../constants";

const localUserRoles = [RoleName.Admin, RoleName.Analyst];

export const useIsManagerUser = (): boolean => {
  const userRole = useUserRoleSelector();

  if (!userRole) return false;

  return localUserRoles.includes(userRole.name as RoleName);
};
